<template>
  <div>
    <div class="attendance-list-p">
      <p
        class="fa fa-lightbulb-o info-button fa-lg"
        @click="$emit('startTour')"
      />
    </div>
    <div
      class="attendance-list-p"
      data-v-step="attendances"
    >
      <p class="attendance-count">
        {{ trans('core.attended') }}: {{ studentsAttended }} | {{ trans('core.absent') }}: {{
          studentsAbsent }}
      </p>
    </div>
    <div
      class="hidden-xs d-none d-sm-block"
      style="flex: 1 1 auto;"
      data-v-step="additional"
    >
      <suggest
        :course-id="courseId"
        :lesson-id="lessonId"
        :clear-on-select="true"
        url="/employee/suggest/students"
        :placeholder="trans('core.add_object', { 'object': trans('core.student') }) + '...'"
        :show-top="true"
        :create-new-student="createNewStudent"
        autofocus
        @select="addStudent"
        @select_new_student="openNewStudentModal"
      />
    </div>
    <div
      class="visible-xs d-sm-none"
      style="flex: 1 1 auto"
    />

    <div
      class="visible-xs d-sm-none pull-right"
      style="margin-top:-30px;"
      data-v-step="additional_small"
    >
      <button
        class="attendance-list-button button-plus"
        type="button"
      >
        <span
          class="attendance-list-p"
          @click="openModal"
        >&plus;</span>
      </button>

      <modal
        :open="open"
        :title="modalTitle"
        @close="closeModal"
      >
        <div class="row">
          <div class="col-md-12">
            {{ trans('attendance_list.type_student_name') }}

            <suggest
              :course-id="courseId"
              :lesson-id="lessonId"
              :clear-on-select="true"
              url="/employee/suggest/students"
              :placeholder="trans('core.add_object', { 'object': trans('core.student') }) + '...'"
              :show-top="false"
              :create-new-student="createNewStudent"
              @select="addStudent"
              @select_new_student="openNewStudentModal"
            />
          </div>
        </div>
      </modal>
    </div>

    <modal
      :open="openNewStudent"
      :title="newStudentModalTitle"
      @close="closeNewStudentModal"
    >
      <form>
        <div class="form-group">
          <label for="number">{{ trans('core.student_no') }}</label>
          <input
            id="number"
            v-model="newStudentNumber"
            type="text"
            class="form-control"
            name="number"
          >
          <div
            v-if="errors.number && (newStudentNumber == null || newStudentNumber === '')"
            class="alert alert-danger"
          >
            <p v-text="errors.number" />
          </div>
        </div>
        <div class="form-group">
          <label for="firstName">{{ trans('core.firstname') }}</label>
          <input
            id="firstName"
            v-model="newStudentFirstName"
            type="text"
            class="form-control"
            name="firstName"
          >
          <div
            v-if="errors.firstName && (newStudentFirstName == null || newStudentFirstName === '')"
            class="alert alert-danger"
          >
            <p v-text="errors.firstName" />
          </div>
        </div>
        <div class="form-group">
          <label for="infixName">{{ trans('core.infixName') }}</label>
          <input
            id="infixName"
            v-model="newStudentInfixName"
            type="text"
            class="form-control"
            name="infixName"
          >
          <div
            v-if="errors.infixName"
            class="alert alert-danger"
          >
            <p v-text="errors.infixName" />
          </div>
        </div>
        <div class="form-group">
          <label for="lastName">{{ trans('core.lastname') }}</label>
          <input
            id="lastName"
            v-model="newStudentLastName"
            type="text"
            class="form-control"
            name="lastName"
          >
          <div
            v-if="errors.lastName && (newStudentLastName == null || newStudentLastName === '')"
            class="alert alert-danger"
          >
            <p v-text="errors.lastName" />
          </div>
        </div>
      </form>

      <button
        type="button"
        class="btn btn-success pull-right"
        @click="addNewStudent"
      >
        {{ trans('core.save') }}
      </button>
      <br style="clear:both;">
    </modal>
  </div>
</template>

<script>
import Modal from './Modal.vue'
import Suggest from './Suggest.vue'
import toast from '../../../services/toast'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'AttendanceListFooter',

  components: { Suggest, Modal },

  props: {
    courseId: {
      required: true,
      type: String,
    },
    lessonId: {
      required: true,
      type: String,
    },
    studentsAttended: {
      required: true,
    },
    studentsAbsent: {
      required: true,
    },
    createNewStudent: {
      required: false,
      default: true,
    },
  },

  data () {
    return {
      open: false,
      openNewStudent: false,
      newStudentNumber: null,
      newStudentFirstName: null,
      newStudentInfixName: '',
      newStudentLastName: null,
      errors: [],
    }
  },

  computed:
      {
        attendedStudentIds () {
          return this.$store.state.attendancelist.attendances.studentIds
        },
        modalTitle () {
          return Lang.trans('core.add_object', { object: Lang.trans('core.student') })
        },
        newStudentModalTitle () {
          return Lang.trans('attendance_list.new_student')
        },
        attendanceListEnabled () {
          return this.$store.state.attendancelist.registrationAvailable
        },
      },

  watch: {},

  mounted () {
  },

  methods: {
    addStudent (studentId) {
      if (!this.attendanceListEnabled) {
        const data = {
          studentIds: [studentId],
          attended: false,
          unexpected: true,
          courseId: this.courseId,
          lessonId: this.lessonId,
        }
        this.$emit('attendanceRegistrationAttemptWhenDisabled', data)
        return
      }

      if (this.attendedStudentIds.indexOf('' + studentId) >= 0) {
        return toast.warning(Lang.trans('attendance_list.already_attended'))
      } else {
        this.$store.dispatch('change_attendance', {
          courseId: this.courseId,
          lessonId: this.lessonId,
          studentIds: [studentId],
          attended: false,
          unexpected: true,
        }).then(response => {
          const id = 'student-row-' + studentId
          if(document.getElementById(id) != null) {
            document.getElementById(id).scrollIntoView()
          }
        }).catch(error => defaultErrorMessage(error))
      }

      this.closeModal()
    },

    addNewStudent () {
      const postData = {
        number: this.newStudentNumber,
        firstName: this.newStudentFirstName,
        infixName: this.newStudentInfixName,
        lastName: this.newStudentLastName,
      }

      this.$store.dispatch('new_student', { courseId: this.courseId, lessonId: this.lessonId, postData })
        .then((response) => {
          this.closeNewStudentModal()
          const id = 'student-row-' + this.attendedStudentIds[this.studentsAttended - 1]
          document.getElementById(id).scrollIntoView()
          toast.success(Lang.trans('attendance_list.new_student_added'))
        })
        .catch(error => {
          if (error.response.status == 422) {
            this.errors = []
            const serverErrors = error.response.data
            const keys = Object.keys(serverErrors)
            for (const key in keys) {
              Vue.set(this.errors, keys[key], serverErrors[keys[key]][0])
            }
          } else {
            return defaultErrorMessage(error)
          }
        })
    },

    openModal () {
      this.open = true
    },

    closeModal () {
      this.open = false
    },

    openNewStudentModal (studentName) {
      if (!this.attendanceListEnabled) {
        this.$emit('attendanceRegistrationAttemptWhenDisabled')
        return
      }
      this.newStudentFirstName = studentName
      this.openNewStudent = true
      this.open = false
    },

    closeNewStudentModal () {
      this.openNewStudent = false
      this.newStudentFirstName = null
      this.newStudentInfixName = null
      this.newStudentLastName = null
      this.newStudentNumber = null
      this.errors = []
    },
  },
}
</script>

<style scoped>

    .attendance-list-p {
        display: inline-block;
        vertical-align: middle;
        font-size: 13px;
        color: white;
    }

    .info-button {
        padding-top: 10px;
        cursor: pointer;
    }

    .attendance-count {
        padding-top: 8px;
        padding-left: 13px;
        padding-right: 13px;
    }

    .attendance-list-button {
        display: inline-block;
        background-color: #25167a;
        border: none;
        margin: 10px;
        padding: 10px 17px;
        text-align: center;
    }

    .button-plus {
        background-color: #42b983 !important; /*rgb(77, 153, 65);*/
        border-radius: 100%;
        height: 40px;
    }

    .alert {
        padding: 6px;
    }

</style>
